import type { PlanUsage } from "@/common/types/planUsage";
import { create } from "zustand";
import { getAvailableMinutes } from "@/services/minutes";

export interface RecordingUsage {
  planUsage?: PlanUsage;
  loading: boolean;
  getAvailablePlanMinutes: () => number;
  getAvailableAdditionalMinutes: () => number;
  fetchAndSetAvailableMinutes: (userId: number) => Promise<void>;
}

export const useRecordingUsageStore = create<RecordingUsage>()((set, get) => ({
  loading: false,
  planUsage: undefined,
  getAvailablePlanMinutes: (): number => get().planUsage?.availableMinutes || 0,
  getAvailableAdditionalMinutes: (): number =>
    get().planUsage?.availableAdditionalMinutes || 0,
  fetchAndSetAvailableMinutes: async (userId: number): Promise<void> => {
    try {
      set({ loading: true });
      const userMinutesData = await getAvailableMinutes(userId);
      set({ planUsage: userMinutesData });
    } catch {
      // soft catch
    } finally {
      set({ loading: false });
    }
  },
}));
